import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import { TbTargetArrow } from "react-icons/tb";
import {
  IoIosStar,
  IoIosStarOutline,
  IoMdInformationCircleOutline,
} from "react-icons/io";
import { FaFileInvoice, FaFileInvoiceDollar } from "react-icons/fa";
import Data from "../../data/data.json";

const dailyupdate_dataa = [
  { value: "₹ 2.5 Cr", title: "Yesterdays Revenue", icon: <TbTargetArrow /> },
  {
    value: "50%",
    title: "This Month Target Vs Achievement",
    icon: <TbTargetArrow />,
  },
  { value: " ₹ 7800", title: "Average invoice value", icon: <FaFileInvoice /> },
  { value: "2.2", title: "Item per invoice", icon: <FaFileInvoiceDollar /> },
];
const mostVisitedArray = [
  {
    id: "67ebdb3ceae75e8b74d72343",
    name: "Blinkit",
    type: "workbook",
    favourite: false,
    icon: "https://res.cloudinary.com/dccfiolig/image/upload/v1743579485/screenshots/67ebdb3c4416e8f10452bee9_dashboard.png",
    selectedSheetId: "67ebdb3c4416e8f10452bee9",
    parentFolder: "66b4b31b5ae8edd2283da40a",
  },
  {
    id: "67dd3bd3a422a148f28439fb",
    name: "Point Mapping",
    type: "workbook",
    favourite: false,
    icon: "https://res.cloudinary.com/dccfiolig/image/upload/v1742552823/screenshots/67dd3bd37db98d26cda56f5b_chart.png",
    selectedSheetId: "67dd3bd37db98d26cda56f5b",
    parentFolder: "66b4b31b5ae8edd2283da40a",
  },
  {
    id: "67458ab34439c230e532bdbf",
    name: "Target Vs. Achievement",
    type: "workbook",
    favourite: false,
    icon: "https://res.cloudinary.com/dccfiolig/image/upload/v1734672975/screenshots/0d785a43-fa89-4fc1-b593-6a27eaf3f864_dashboard.png",
    selectedSheetId: "6757bad91b117b49d2de5626",
    parentFolder: "66b4b31b5ae8edd2283da40a",
  },
  {
    id: "67f399b341a221213c73736a",
    name: "Human Hydro",
    type: "workbook",
    favourite: false,
    icon: "https://res.cloudinary.com/dccfiolig/image/upload/v1744018054/screenshots/67f399b32219a544fdc81cd7_dashboard.png",
    selectedSheetId: "67f399b32219a544fdc81cd7",
    parentFolder: "66b4b31b5ae8edd2283da40a",
  },
  {
    id: "67e3d84a99a7f46d8f9c1c13",
    name: "Region sales on year",
    type: "workbook",
    favourite: false,
    icon: "https://res.cloudinary.com/dccfiolig/image/upload/v1742985302/screenshots/67e3d771989c5cb969766591_chart.png",
    selectedSheetId: "67e3d849bab8f17dfa723a1e",
    parentFolder: "679709a477b9962e39696a39",
  },
];
const trendingArray = [
  {
    id: "6728acd0b14daeaf61c5e797",
    name: "origin Destination",
    type: "workbook",
    favourite: false,
    icon: "https://res.cloudinary.com/dccfiolig/image/upload/v1776242924/screenshots/67737ec36018c0fd5d8a6b2e_dashboard.png",
    selectedSheetId: "67737ec36018c0fd5d8a6b2e",
    parentFolder: "66b4b31b5ae8edd2283da40a",
  },
  {
    id: "67e11ac3a422a148f28d4ed7",
    name: "Gamified Dashboard",
    type: "workbook",
    favourite: false,
    icon: "https://res.cloudinary.com/dccfiolig/image/upload/v1743763549/screenshots/67e11ac37db98d26cda56f87_dashboard.png",
    selectedSheetId: "67e11ac37db98d26cda56f87",
    parentFolder: "66b4b31b5ae8edd2283da40a",
  },
  {
    id: "675be4f3db8dcebfd171fdd9",
    name: "category wise sales",
    type: "workbook",
    favourite: false,
    icon: "https://res.cloudinary.com/dccfiolig/image/upload/v1776238563/screenshots/675be4f37d54fba82e08df97_chart.png",
    selectedSheetId: "675be4f37d54fba82e08df97",
    parentFolder: "66b4b31b5ae8edd2283da40a",
  },
  {
    id: "675bfe41af3b2fc3a626376d",
    name: "quantity Vs. Sales",
    type: "workbook",
    favourite: false,
    icon: "https://res.cloudinary.com/dccfiolig/image/upload/v1776242995/screenshots/675bfe411b626ef7b32a6654_chart.png",
    selectedSheetId: "675bfe411b626ef7b32a6654",
    parentFolder: "66b4b31b5ae8edd2283da40a",
  },
  {
    id: "679112484f4450e867ee65a7",
    name: "car sales",
    type: "workbook",
    favourite: false,
    icon: "https://res.cloudinary.com/dccfiolig/image/upload/v1737975524/screenshots/679112486988cc9f8e098f07_chart.png",
    selectedSheetId: "679112486988cc9f8e098f07",
    parentFolder: "66b4b31b5ae8edd2283da40a",
  },
];

export default function Welcome() {
  const [welcomeConetntToDisplay, setWelcomeConetntToDisplay] = useState(
    Data.Most_visited.length
  );
  // console.log(welcomeConetntToDisplay);
  const componentRef = useRef(null);
  const navigate = useNavigate();
  const { open } = useOutletContext();
  // console.log(open);

  const updateItemsToShow = (open) => {
    if (componentRef.current) {
      const width = componentRef.current.offsetWidth;
      let display;
      if (width > 1200) {
        if (open) {
          display = 5;
        }
        display = 6;
      } else if (width > 1000) {
        display = 4;
      } else if (width > 800) {
        display = 3;
      } else if (width > 600) {
        display = 3;
      } else if (width > 400) {
        display = 3;
      } else {
        display = 1;
      }
      setWelcomeConetntToDisplay(display);
    }
  };

  useEffect(() => {
    updateItemsToShow(open);
    window.addEventListener("resize", updateItemsToShow);
    return () => window.removeEventListener("resize", updateItemsToShow);
  }, []);

  const handleShowMore = () => {
    navigate("/home/dash/trending");
  };
  const handleOpenWorkbook = (workbookId, sheetId) => {
    if (workbookId && sheetId) {
      navigate(`/dashboard?workbookid=${workbookId}&sheetid=${sheetId}`);
    } else {
      // console.log("selectedSheetId is null or undefined");
    }
  };

  return (
    <main
      ref={componentRef}
      className="w-full h-[94vh] min-h-[94vh] overflow-hidden overflow-y-auto p-1 flex flex-col gap-8"
    >
      {/* Daily Update */}
      <section className="w-full flex flex-wrap gap-3 px-3 py-3 justify-start h-auto" key="dailyUpdate">
        {dailyupdate_dataa
          .slice(0, welcomeConetntToDisplay)
          .map((add, index) => (
            <div
              key={index}
              className="flex-1 min-w-[120px] max-w-[17%] bg-transparent border border-transparent rounded-md flex flex-col justify-evenly shadow-md h-[125px]"
            >
              <div className="flex justify-between text-2xl w-full px-2">
                {add.icon}
                {/* <PiDotsThreeOutlineVerticalFill /> */}
              </div>
              <span className="flex items-center gap-2 text-lg px-2">
                {add.value}
              </span>
              <span className="text-sm truncate px-2">{add.title}</span>
            </div>
          ))}
      </section>

      {/* Most Visited */}
      <section className="w-full flex flex-col gap-2 px-3 h-auto" key="mostVisited">
        <header className="flex justify-between items-center h-[10%]">
          <h3 className="font-[500]">Most Visited</h3>
          <button
            onClick={handleShowMore}
            className="text-sm underline text-blue-400"
          >
            Show More
          </button>
        </header>
        <section className="flex gap-x-5 gap-y-16 w-full h-[90%]">
          {mostVisitedArray
            .slice(0, welcomeConetntToDisplay)
            .map((item, index) => {
              return (
                <section key={item.id} className="flex flex-col w-[230px] h-[180px] items-center justify-start gap-1">
                  <section
                    className="w-full h-[90%] gap-3 bg-white rounded shadow-md cursor-pointer"
                  >
                    {item !== null && item.type === "folder" ? (
                      <img
                        className="w-full h-full object-contain"
                        src="/graph_img/file.png"
                        alt="Folder"
                      />
                    ) : (
                      <img
                        className="w-full h-full object-contain"
                        src={item !== null && item.icon}
                        alt="File"
                        onClick={() =>
                          handleOpenWorkbook(item.id, item.selectedSheetId)
                        }
                      />
                    )}
                  </section>{" "}
                  <div className="text-[14px] flex justify-between items-start w-full h-[10%]">
                    <h2 className="w-[80%] truncate">{item.name}</h2>
                    <section className="flex gap-3 relative items-start pt-[4px] w-[30%]">
                      {/* Toggle favorite status using handleFavoriteToggle */}
                      {item !== null && item.favourite ? (
                        <IoIosStar />
                      ) : (
                        <IoIosStarOutline />
                      )}
                      <IoMdInformationCircleOutline />
                      <PiDotsThreeOutlineVerticalFill className="text-black cursor-pointer" />
                    </section>
                  </div>
                </section>
              );
            })}
        </section>
      </section>

      {/* Trending */}
      <section className="w-full flex flex-col gap-2 px-3 h-auto" key="trending">
        <header className="flex justify-between items-center h-[10%]">
          <h3 className="font-[500]">Most Trending</h3>
          <button
            onClick={handleShowMore}
            className="text-sm underline text-blue-400"
          >
            Show More
          </button>
        </header>
        <section className="flex gap-x-5 gap-y-16 w-full h-[90%]">
          {trendingArray
            .slice(0, welcomeConetntToDisplay)
            .map((item, index) => {
              return (
                <section key={item.id} className="flex flex-col w-[230px] h-[180px] items-center justify-start gap-1">
                  <section
                    className="w-full h-[90%] gap-3 bg-white rounded shadow-md cursor-pointer"
                  >
                    {item !== null && item.type === "folder" ? (
                      <img
                        className="w-full h-full object-contain"
                        src="/graph_img/file.png"
                        alt="Folder"
                      />
                    ) : (
                      <img
                        className="w-full h-full object-contain"
                        src={item !== null && item.icon}
                        alt="File"
                        onClick={() =>
                          handleOpenWorkbook(item.id, item.selectedSheetId)
                        }
                      />
                    )}
                  </section>{" "}
                  <div className="text-[14px] flex justify-between items-start w-full h-[10%]">
                    <h2 className="w-[80%] truncate">{item.name}</h2>
                    <section className="flex gap-3 relative items-start pt-[4px] w-[30%]">
                      {/* Toggle favorite status using handleFavoriteToggle */}
                      {item !== null && item.favourite ? (
                        <IoIosStar />
                      ) : (
                        <IoIosStarOutline />
                      )}
                      <IoMdInformationCircleOutline />
                      <PiDotsThreeOutlineVerticalFill className="text-black cursor-pointer" />
                    </section>
                  </div>
                </section>
              );
            })}
        </section>
      </section>
    </main>
  );
}
